import { diagramCat } from 'images';
import { SxStyles } from 'types';

export const root: SxStyles = (theme) => ({
  maxWidth: '392px',

  backgroundImage: `url(${diagramCat})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '100% 100%',

  [theme.breakpoints.down('commonSm')]: {
    backgroundImage: 'none',
  },
});

export const container: SxStyles = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',

  [theme.breakpoints.down('commonSm')]: {
    gap: '12px',
  },
});

export const doughnutContainer: SxStyles = (theme) => ({
  display: 'grid',
  placeItems: 'center',

  width: '112px',
  height: '112px',

  [theme.breakpoints.down('commonSm')]: {
    width: '100px',
    height: '100px',
  },
});
